import Select, { MultiValue } from 'react-select';
import Typography from '@mui/joy/Typography';
import { filterOptions, filterValue } from '../TestFilterValues/TestFilterValues';
import { PageType } from '../RunTest';
import './ManualBulkImport.css';

interface ManualImportProps {
  pageTypes: PageType[];
  manualImportData: string;
  setManualImportData: (value: string) => void;
  selectedPageType: PageType | undefined;
  setSelectedPageType: (value: PageType) => void;
  handleManualImport: () => void;
  selectedFilter: string;
  setSelectedFilter: (value: string) => void;
  disabled?: boolean;
  importError?: string;
}

const ManualBulkImport = ({
  pageTypes,
  manualImportData,
  setManualImportData,
  selectedPageType,
  setSelectedPageType,
  handleManualImport,
  selectedFilter,
  setSelectedFilter,
  disabled,
  importError
}: ManualImportProps) => {
  const handleTestFilter = (value: MultiValue<{ value: string; label: string }>) => {
    if (!value) return;

    const mergedValue = value.map((option) => option.value).join('&');
    setSelectedFilter(mergedValue);
  };

  const pageTypeChange = (pageType: PageType) => {
    setSelectedPageType(pageType);
    setSelectedFilter('');
  };

  const disabledImport = !selectedPageType || !manualImportData || disabled;

  return (
    <>
      <label htmlFor="manualImport--textarea">URL's</label>
      <textarea
        id="manualImport--textarea"
        className="manualImport-textarea"
        rows={6}
        value={manualImportData}
        onChange={(e) => setManualImportData(e.target.value)}
      />
      <div className="manualImport-columns">
        <Select
          styles={{ container: (base) => ({ ...base, width: '50%' }) }}
          placeholder="Select page type"
          options={pageTypes}
          value={selectedPageType !== undefined && selectedPageType}
          onChange={(selectedOption) => selectedOption && pageTypeChange(selectedOption)}
        />
        <Select
          styles={{ container: (base) => ({ ...base, width: '50%' }) }}
          placeholder="Select filter"
          isClearable={true}
          isMulti={true}
          isDisabled={!selectedPageType}
          options={selectedPageType && filterOptions(selectedPageType.value)}
          value={filterValue(selectedFilter)}
          onChange={(value) => handleTestFilter(value)}
        />
      </div>
      <div className="manualImport-btns">
        <button
          className="button button--default button--inverseBlack"
          type="button"
          onClick={handleManualImport}
          disabled={disabledImport}
        >
          Import
        </button>
      </div>
      {importError && (
        <Typography textAlign="center" level="body-md" color="danger" sx={{ mt: 1 }}>
          {importError}
        </Typography>
      )}
    </>
  );
};

export default ManualBulkImport;
